import { render } from "./CustomAreaDetails.vue?vue&type=template&id=2664eeaf&scoped=true"
import script from "./CustomAreaDetails.vue?vue&type=script&lang=js"
export * from "./CustomAreaDetails.vue?vue&type=script&lang=js"

import "./CustomAreaDetails.vue?vue&type=style&index=0&id=2664eeaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2664eeaf"]])

export default __exports__